import { useContext } from "react"
import { NotificationsContext } from "../../context/NotificationContext"
import { AudienceSummary, ButtonGroup, PreviewSidebar, PreviewSidebarContent, PreviewTitle, SelectedAudienceContainer, UserTypeBadge, WrapperH1, } from "../../styles"
import { Button as ButtonKeychain } from "@habitech/call-to-action"
import Modal from "src/components/common/modal/Modal"
import Loading from "src/components/common/Loading/Loading"
import { formatDateNotifications } from "src/helpers/formatDate"
import { TabBarContext } from "src/components/common/TabSwich"

interface UserType {
    id: string;
    name: string;
    value: string;
}

const userTypes: UserType[] = [
    { id: 'owner', name: 'Propietario', value: 'Owner' },
    { id: 'independent', name: 'Agente Independiente', value: 'Independent agent' },
    { id: 'medium_broker', name: 'Medium Broker', value: 'Medium broker' },
    { id: 'big_broker', name: 'Big Broker', value: 'Big broker' },
    { id: 'enterprise', name: 'Enterprise', value: 'Enterprise' },
];

export const PreViewComponent = () => {
    const {
        dataFilters,
        selectedUserTypes,
        hasFeatured,
        numberUsers,
        loading,
        showModal,
        created,
        customQuery,
        customQueryError,
        handleResetForm,
        handleCloseModal,
        handleSubmit,
    } = useContext(NotificationsContext);
    const { setTab } = useContext(TabBarContext);

    const handleClose = () => {
        setTab('tab-1')
        handleResetForm()
    }

    if (!showModal) {
        return null;
    }

    let modalContent;

    if (loading) {
        modalContent = <Loading />;
    } else if (created) {
        modalContent = <WrapperH1><h1 className="notification">Notificación creada</h1>
            <ButtonKeychain dataId="close" originType="pcom" onClick={handleClose}>
                Cerrar
            </ButtonKeychain></WrapperH1>;
    } else {
        modalContent = (
            <>
                <PreviewSidebar>
                    <PreviewSidebarContent>
                        <PreviewTitle>Audiencia Seleccionada</PreviewTitle>
                        {!customQuery && <>
                            <SelectedAudienceContainer>
                                {selectedUserTypes.length > 0 ? (
                                    <div>
                                        {selectedUserTypes.map((value) => (
                                            <UserTypeBadge key={value}>
                                                {userTypes.find((t) => t.value === value)?.name}
                                            </UserTypeBadge>
                                        ))}
                                    </div>
                                ) : (
                                    <p>No hay tipos de usuario seleccionados</p>
                                )}
                            </SelectedAudienceContainer>

                            <AudienceSummary>
                                <p>Fuente: {dataFilters.user_source === "feed" ? "Feed" : "Manual"}</p>
                                {hasFeatured && (
                                    <p>
                                        Con {dataFilters.featuredMin}-{dataFilters.featuredMax} propiedades destacadas
                                    </p>
                                )}
                                <p>
                                    Con {dataFilters.propertiesActiveMin}-{dataFilters.propertiesActiveMax} propiedades activas
                                </p>
                                <p>
                                    Con {dataFilters.leadsMin}-{dataFilters.leadsMax} leads generados entre las fechas{" "}
                                    <br />
                                    {formatDateNotifications(dataFilters.leadsDateMin)} y{" "}
                                    {formatDateNotifications(dataFilters.leadsDateMax)}
                                </p>
                            </AudienceSummary></>}
                        {/* eslint-disable-next-line eqeqeq */}
                        {!!customQuery && <>{customQueryError != "" ? customQueryError : customQuery}</>}
                        <p style={{ fontWeight: "bold", marginTop: "1rem" }}>
                            Audiencia estimada: {numberUsers} usuarios
                        </p>
                    </PreviewSidebarContent>
                </PreviewSidebar>
                <ButtonGroup>
                    {<ButtonKeychain
                        dataId="cancel"
                        variant="stroke"
                        onClick={handleCloseModal}
                        originType="pcom"
                    >
                        Cancelar
                    </ButtonKeychain>}
                    {
                        <ButtonKeychain
                            dataId="showModal"
                            originType="pcom"
                            onClick={handleSubmit}
                            loading={loading}
                            disabled={!!customQueryError || numberUsers === 0}
                        >
                            Crear notificación
                        </ButtonKeychain>
                    }
                </ButtonGroup>
            </>
        );
    }

    return <Modal onClose={created ? handleResetForm : handleCloseModal}>{modalContent}</Modal>;
};